(function() {
  if (!window.location.pathname.includes("/collections/")) return;

  const key = "scroll:" + window.location.pathname;

  function restoreScroll() {
    const saved = sessionStorage.getItem(key);
    if (!saved) return;

    const pos = parseInt(saved, 10);

    if (document.body.scrollHeight < pos + 50) {
      setTimeout(restoreScroll, 30);
      return;
    }

    window.scrollTo({
      top: pos,
      behavior: "instant"  
    });
  }

  document.addEventListener("DOMContentLoaded", restoreScroll);

  window.addEventListener("pageshow", function(e) {
    if (e.persisted) restoreScroll();
  });

  document.body.addEventListener("click", (e) => {
    const link = e.target.closest("a");
    if (!link) return;

    if (link.href.includes("/products/")) {
      sessionStorage.setItem(key, String(window.scrollY));
    }
  });
})();
